import { IncomingMessage } from "node:http";
import { NextApiRequestCookies } from "next/dist/server/api-utils";

type NextRequest = IncomingMessage & {
  cookies: NextApiRequestCookies;
};

export const server = {
  isServerSide: globalThis.window === undefined,

  log: (...args: Parameters<typeof console.log>) => {
    if (!server.isServerSide) {
      return;
    }
    console.log(...args);
  },

  logPageVisit: (req: NextRequest) => {
    const fwdIpStr = server.getForwardIPString(req);
    const url = req.url;
    const remoteAddress = req.socket.remoteAddress;
    server.log(`INFO__PAGE_VISIT `, url, remoteAddress, fwdIpStr);
  },

  getForwardIPString: (req: NextRequest) => {
    return req.headers["x-forwarded-for"]
      ? ` - header.x-forwarded-for:${req.headers["x-forwarded-for"]}`
      : "";
  },
};

export const client = {
  isClientSide: globalThis.window !== undefined,

  log: (...args: Parameters<typeof console.log>) => {
    if (!client.isClientSide) {
      return;
    }
    console.log(...args);
  },
};
